var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { defineComponent as _defineComponent } from 'vue';
import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { class: "cart-promo__block" };
var _hoisted_2 = { class: "form-group" };
var _hoisted_3 = { class: "form-field form-field--text form-field--1 form-field--m form-field--primary" };
import { ref } from 'vue';
import CartEventBus from "../../CartEventBus";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CouponInput',
    setup: function (__props) {
        var coupon = ref('');
        var input = ref();
        function onkeypress(e) {
            e.preventDefault();
            input.value.blur();
            enterCoupon();
        }
        function enterCoupon() {
            if (coupon.value.trim() !== '') {
                CartEventBus.emit('coupons:add', coupon.value);
                coupon.value = '';
            }
        }
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                name: "coupon_code",
                                class: "form-control",
                                placeholder: "Промокод на скидку",
                                ref_key: "input",
                                ref: input,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((coupon).value = $event); }),
                                onChange: enterCoupon,
                                onKeypress: _withKeys(onkeypress, ["enter"])
                            }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                [_vModelText, coupon.value]
                            ])
                        ])
                    ])
                ]),
                _cache[2] || (_cache[2] = _createTextVNode()),
                _createElementVNode("div", { class: "cart-promo__block" }, [
                    _createElementVNode("button", {
                        type: "button",
                        class: "btn btn--2 btn--m btn--black wide",
                        id: "coupon_button",
                        onClick: enterCoupon
                    }, __spreadArray([], __read((_cache[1] || (_cache[1] = [
                        _createElementVNode("span", { class: "btn__label" }, "Применить", -1 /* CACHED */)
                    ]))), false))
                ])
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
